import { Component } from 'react';
import { UtilsService } from '../../services/UtilsService';
import { HttpRequestService } from '../../services/HttpRequestService';
import Pagination from '../../common/Pagination';
import { Link } from "react-router-dom";
import moment from 'moment'

class CustomerMassImportLog extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            massImports: [],
            pageCount: 0,
            pageIndex: 0
        }
        this.paramsKey = "params.mass-import-log";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handlePageChange = this.handlePageChange.bind(this);
        this.pageSize = 50;
        this.getMassImports = this.getMassImports.bind(this);
    }

    componentDidMount() {
        this.getMassImports(this.state.pageIndex);
    }

    handlePageChange(page) {
        this.getMassImports(page);
    }

    getMassImports(page) {
        this.setState({ pageIndex: page });
        var params = {
            status: this.state.status,
            pageSize: this.pageSize,
            pageIndex: page
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Crm/GetMassImports', params).then(data => {
            this.setState({ massImports: data.data, pageCount: parseInt(Math.ceil(data.count / this.pageSize)) });
        });
    }

    revertImport(massImport) {
        this.utils.confirm("Accounts and orders created through this mass import will be deleted. Are you sure?", () => {
            var params = {
                id: massImport.massImportID
            }
            this.http.get('/api/Crm/RevertMassImport', params).then(data => {
                this.utils.info("It will take some time to revert the import. You will receive an email once the process is complete.");
                this.getMassImports(0);
            });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Mass Import Log</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row">
                                    <table className="table table-striped mt-1">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th scope="col">Created by</th>
                                                <th scope="col">Status</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.massImports.map((massImport) =>
                                                <tr key={massImport.massImportID}>
                                                    <td><Link to={"/customers/mass-import/" + massImport.massImportID}>{moment(massImport.timestamp).format("l")}</Link></td>
                                                    <td>{massImport.username}</td>
                                                    <td>{massImport.status}</td>
                                                    <td>
                                                        {massImport.status === "completed" &&
                                                            <button className="btn btn-sm btn-info" onClick={e => this.revertImport(massImport)}>Revert <i className="fas fa-undo"></i></button>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.massImports.length > 0 &&
                                            <Pagination pageIndex={this.state.pageIndex} pageCount={this.state.pageCount} onPageChanged={this.handlePageChange}></Pagination>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerMassImportLog;
